module.exports = __webpack_public_path__ + "static/fonts/Mont-LightItalic.210093c.eot";